import React, { useCallback, useState } from 'react'
import Container from './Container'
import CustomDragLayer from './CustomDragLayer'
import styles from './DragAndDrop.module.scss'

export default function DraggableArea({ fields, setFields, imageUrl, template }) {
  const [snapToGridAfterDrop, setSnapToGridAfterDrop] = useState(false)
  const [snapToGridWhileDragging, setSnapToGridWhileDragging] = useState(false)
  const handleSnapToGridAfterDropChange = useCallback(() => {
    setSnapToGridAfterDrop(!snapToGridAfterDrop)
  }, [snapToGridAfterDrop])
  const handleSnapToGridWhileDraggingChange = useCallback(() => {
    setSnapToGridWhileDragging(!snapToGridWhileDragging)
  }, [snapToGridWhileDragging])
  return (
    <div>
      <Container
        snapToGrid={snapToGridAfterDrop}
        fields={fields}
        setFields={setFields}
        imageUrl={imageUrl}
        template={template}
      />
      <CustomDragLayer snapToGrid={snapToGridWhileDragging} />
      <p>
        <label htmlFor="snapToGridWhileDragging">
          <input
            id="snapToGridWhileDragging"
            type="checkbox"
            checked={snapToGridWhileDragging}
            onChange={handleSnapToGridWhileDraggingChange}
          />
          <small className={styles.draggableAreaSettingsLabel}>Snap to grid while dragging</small>
        </label>
        <br />
        <label htmlFor="snapToGridAfterDrop">
          <input
            id="snapToGridAfterDrop"
            type="checkbox"
            checked={snapToGridAfterDrop}
            onChange={handleSnapToGridAfterDropChange}
          />
          <small className={styles.draggableAreaSettingsLabel}>Snap to grid after drop</small>
        </label>
      </p>
    </div>
  )
}
